<template>
  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @close-modal="closeModal"
    modal-alignment="top"
    modal-size="full-width"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <div class="row">
        <div class="col-12 mt-4">
          <app-table :id="tableId" :options="options" @action="getListAction" />
        </div>
      </div>
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { TableHelpers } from "./TableHelpers";
export default {
  mixins: [ModalMixin, TableHelpers],
  props: {
    id: Number,
  },
  data() {
    return {
      preloader: false,
      modalId: "historical-modal",
      modalTitle: "",

      tableId: "historical-table",
      rowData: {},
      options: {
        url: `accreditations/sampling/${this.id}/historical`,
        name: "",
        showHeader: true,
        columns: [],
        actions: [],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: false,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  computed: {
    title() {
      return "Historio del muestreo";
    },
  },
  created() {
    this.options.columns = [...this.tableColumns, this.columnStatus];
  },

  methods: {
    getListAction(rowData, actionObj, active) {},
  },
};
</script>
